import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import { UserService } from '../services/user.service';

export const adminGuard: CanActivateFn = () => {
  const nav = inject(NavigationService);

  return inject(UserService).user$.pipe(
    map(user => !!user?.superAdmin),
    tap(isSuperAdmin => {
      if (!isSuperAdmin) nav.navigateTo(['/budgets']);
    }),
  );
};
